
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class CustomerDialog extends Serenity.EntityDialog<CustomerRow, any> {
        protected getFormKey() { return CustomerForm.formKey; }
        protected getIdProperty() { return CustomerRow.idProperty; }
        protected getLocalTextPrefix() { return CustomerRow.localTextPrefix; }
        protected getNameProperty() { return CustomerRow.nameProperty; }
        protected getService() { return CustomerService.baseUrl; }
        protected getInsertPermission() { return CustomerRow.insertPermission; }
        protected getUpdatePermission() { return CustomerRow.updatePermission; }
        protected getDeletePermission() { return CustomerRow.deletePermission; }
        protected useViewMode() { return true; }
        //protected isViewMode() { return true; }


        protected form = new CustomerForm(this.idPrefix);
        private loadedState: string;
        constructor() {
            super();
            //if (this.getSaveState()) {
            //    Serenity.EditorUtils.setReadOnly(this.form.State, true);
            //    Serenity.EditorUtils.setReadOnly(this.form.City, true);
            //}
            q.setTextRightAlign(this.form.Coef);
            q.hideEditorLabel(this.form.AddressDetails);
            q.hideEditorLabel(this.form.ContactDetails);
            q.hideCategorylinks(this.element);
            DialogUtils.pendingChangesConfirmation(this.element, () => this.getSaveState() != this.loadedState);

            this.form.LbrFlag.changeSelect2(e => {
                if (this.form.LbrFlag.value == true) {
                    Serenity.EditorUtils.setReadOnly(this.form.LbrAddDisc, false);
                    Serenity.EditorUtils.setReadOnly(this.form.LbrAddMkp, false);
                    Serenity.EditorUtils.setReadOnly(this.form.LbrFromDate, false);
                    Serenity.EditorUtils.setReadOnly(this.form.LbrToDate, false);
                } else {
                    Serenity.EditorUtils.setReadOnly(this.form.LbrAddDisc, true);
                    Serenity.EditorUtils.setReadOnly(this.form.LbrAddMkp, true);
                    Serenity.EditorUtils.setReadOnly(this.form.LbrFromDate, true);
                    Serenity.EditorUtils.setReadOnly(this.form.LbrToDate, true);
                }
            });
            this.form.StnFlag.changeSelect2(e => {
                if (this.form.StnFlag.value == true) {

                    Serenity.EditorUtils.setReadOnly(this.form.StnAddDisc, false);
                    Serenity.EditorUtils.setReadOnly(this.form.StnAddMkp, false);
                    Serenity.EditorUtils.setReadOnly(this.form.StnFromDate, false);
                    Serenity.EditorUtils.setReadOnly(this.form.StnToDate, false);
                } else {

                    Serenity.EditorUtils.setReadOnly(this.form.StnAddDisc, true);
                    Serenity.EditorUtils.setReadOnly(this.form.StnAddMkp, true);
                    Serenity.EditorUtils.setReadOnly(this.form.StnFromDate, true);
                    Serenity.EditorUtils.setReadOnly(this.form.StnToDate, true);
                }
            });
            this.form.TaxRegType.changeSelect2(e => {
                if (this.form.TaxRegType.value == "289")
                    Serenity.EditorUtils.setRequired(this.form.GstVat, true);
                else
                    Serenity.EditorUtils.setRequired(this.form.GstVat, false);
            });

            this.form.CustomerPrefix.changeSelect2(e => {
                if (this.form.CustomerPrefix.value.length != 3) {
                    q.Alert('', 'Prefix should be 3 characters', 2999, true);
                    return false;
                }
                OMS.CustomerService.ValidatePrefix({ CustomerPrefix: this.form.CustomerPrefix.value }, response => {
                    if (response.Entities != null && response.Entities.length > 0) {
                        q.Alert('', 'Prefix exists. Cannot save!', 2999, true);
                        return false;
                    }
                }, { async: false });
                this.form.CustomerPrefix.value = this.form.CustomerPrefix.value.toUpperCase();
            })
        }
        getSaveState() {
            try {
                return $.toJSON(this.getSaveEntity());
            }
            catch (e) {
                return null;
            }
        }


        loadResponse(data) {
            super.loadResponse(data);
            this.loadedState = this.getSaveState();
        }
        protected onDialogOpen() {
            super.onDialogOpen();
            if (this.form.LedgerName.value == "") {
                var userdefinition = Q.Authorization.userDefinition;
                if (userdefinition.CurrencyId != null)
                    this.form.CurrencyId.value = userdefinition.CurrencyId.toString();
            }
        }
        protected validateBeforeSave() {
            super.validateBeforeSave();
            var defaultaddress = this.form.AddressDetails.getItems().filter(x => x.Default == true);
            if (defaultaddress.length == 0) {
                q.Alert('', 'Atleast One Default Address Required', 2999, true);
                return false;
            }
            if (defaultaddress.length > 1) {
                q.Alert('', 'Multiple Default Address not Allowed', 2999, true);
                return false;
            }
            var defaultcontact = this.form.ContactDetails.getItems().filter(x => x.IsDefault == true);
            if (defaultcontact.length == 0) {
                q.Alert('', 'Atleast One Default Contact Required', 2999, true);
                return false;
            }
            if (defaultcontact.length > 1) {
                q.Alert('', 'Multiple Default Contact not Allowed', 2999, true);
                return false;
            }
            if (this.form.CustomerPrefix.value.length != 3) {
                q.Alert('', 'Prefix should be 3 characters', 2999, true);
                return false;
            }
            return true;
        }

    }
}